import { Injectable } from '@angular/core';
import { ADPResourceService as ResourceService } from 'digital-core';


@Injectable()
export class DateTimeService {

  constructor(public resourceService: ResourceService) { }

  public getFormat(): string {
    let format = this.resourceService.getPortalSetting("Client_DateFormat");
    if (format) {
      return format.Value;
    }
    return "MM-DD-YYYY";
  }

  public getLocale(): string {
    let format = this.resourceService.getPortalSetting("Client_Culture");
    if (format) {
      return format.Value;
    }
    return "en-US";
  }

  public getTodayDateWithOutTime(dateFormat?: string) {
    if (!!dateFormat) {
      return new Date(this.resourceService.getFormattedLocalDate(new Date().toDateString(), dateFormat));
    } else {
      return new Date(this.resourceService.getFormattedLocalDate(new Date().toDateString()
        , this.resourceService.getPortalSetting("Client_DateFormat").Value));
    }

  }

  public getDateWithOutTime(date: Date, dateFormat?: string) {
    if (!!dateFormat) {
      return new Date(this.resourceService.getFormattedLocalDate(date.toDateString(), dateFormat));
    } else {
      return new Date(this.resourceService.getFormattedLocalDate(date.toDateString()
        , this.resourceService.getPortalSetting("Client_DateFormat").Value));
    }
  }
}
